import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { usersInitialState } from './interfaces';
import { IUserData } from '../../../types/users/IUser';

export const usersReducer = createSlice({
  name: 'users',
  initialState: usersInitialState,
  reducers: {
    setUsersAction: (state, action: PayloadAction<IUserData[]>) => {
      state.users = action.payload;
    },
    setUsersFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.usersFetchStatus = action.payload;
    },
    setUsersErrorAction: (state, action: PayloadAction<string | null>) => {
      state.usersError = action.payload;
    },
  },
});

export const { setUsersAction, setUsersFetchStatusAction, setUsersErrorAction } = usersReducer.actions;
